import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { PaymentAccount } from './payment-account';
import { PaymentStatus } from './payment-status';
import { ReservationDetail } from './reservation-detail';

@inheritSerialization(AbstractModel)
export class Payment extends AbstractModel {
  @autoserializeAs(PaymentAccount)
  paymentAccount: PaymentAccount;

  @autoserialize
  paymentDescription: string;

  @autoserialize
  amount: number;

  @autoserialize
  processedAmount: number;

  @autoserializeAs(PaymentStatus)
  paymentStatus: PaymentStatus;

  @autoserializeAs(ReservationDetail)
  reservationDetail: ReservationDetail;
}
